export const getReportsType = (state) => state.report?.type;
export const getReportsAreas = (state) => state.report?.area;
export const getReportEnforcementAgencies = (state) => state.report?.enforcementAgencies;
export const getReportAssessmentsForms = (state) => state.report?.assessmentsForms;
export const getReportEducationForms = (state) => state.report?.educationForms;
export const getReportEnforcementForms = (state) => state.report?.enforcementForms;
